// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"b577f5af","642":"c9157cae","725":"bccb3a3a","787":"2f9b58c0"}[chunkId] + ".chunk.js";
};